/* Serial Seal — creature motif pack.
 * Extends SS_ART.motif in place. Drawn with SS_ART's own helpers so every
 * motif obeys the material rule: ink is painted AROUND the shine, the holes
 * punched through an inked field ARE the live holographic foil.
 *
 * Six motifs, two groups:
 *   flamecrest / aquacrest / leafcrest / boltcrest — one badge, four elements
 *   eggshell / energyorb                          — the collector's objects
 *
 * These are ORIGINAL heraldry in the creature-collector genre. Nothing here
 * reproduces anybody's mark: the elements sit in a chamfered shield of our own
 * drawing, never on a coloured disc, and every subject carries internal
 * linework so it reads as illustration rather than as a pip.
 */
(function () {
  'use strict';
  var A = window.SS_ART;
  if (!A) return;

  var INK = A.INK, INK2 = A.INK2, INK3 = A.INK3, L1 = A.L1, L2 = A.L2;
  var r2 = A.r2;

  function poly(pts) {
    var d = '', i;
    for (i = 0; i < pts.length; i++) d += (i ? 'L' : 'M') + r2(pts[i][0]) + ' ' + r2(pts[i][1]);
    return d + 'Z';
  }

  /* A closed outline swept along a centreline. Anything organic that has to be
     a HOLE — a crack, a talon — needs real geometry: a stroke can never be a
     hole, because foil is the absence of ink, not a colour you can paint. */
  function ribbon(pts, w) {
    var lo = [], hi = [], i, a, b, nx, ny, len, hw;
    for (i = 0; i < pts.length; i++) {
      a = pts[i > 0 ? i - 1 : 0];
      b = pts[i < pts.length - 1 ? i + 1 : pts.length - 1];
      nx = -(b[1] - a[1]); ny = (b[0] - a[0]);
      len = Math.sqrt(nx * nx + ny * ny) || 1;
      hw = (typeof w === 'function' ? w(i / (pts.length - 1)) : w) / 2;
      nx = nx / len * hw; ny = ny / len * hw;
      lo.push([pts[i][0] + nx, pts[i][1] + ny]);
      hi.unshift([pts[i][0] - nx, pts[i][1] - ny]);
    }
    return poly(lo.concat(hi));
  }

  function quad(p0, c, p1, n) {
    var out = [], k, t, u;
    for (k = 0; k <= n; k++) {
      t = k / n; u = 1 - t;
      out.push([u * u * p0[0] + 2 * t * u * c[0] + t * t * p1[0],
                u * u * p0[1] + 2 * t * u * c[1] + t * t * p1[1]]);
    }
    return out;
  }

  /* ——————————— the crest family ———————————
     A chamfered shield with an indented chief: deliberately NOT the rounded
     heater shield SS_ART.crest already uses, so the four read as their own
     series sitting beside it. Every part is derived from one vertex list
     scaled about the badge centre — the border band, the stud track and the
     inner chamber can never drift out of register with each other. */
  var SHELL = [[16, 20], [50, 24], [84, 20], [84, 56], [74, 78], [50, 104], [26, 78], [16, 56]];
  var BX = 50, BY = 62;

  function shellPts(k) {
    return SHELL.map(function (p) { return [BX + (p[0] - BX) * k, BY + (p[1] - BY) * k]; });
  }
  function shell(k) { return poly(shellPts(k)); }

  /* a point at fraction t around the badge outline, used to space the studs
     evenly across eight edges of unequal length */
  function along(k, t) {
    var p = shellPts(k), seg = [], total = 0, i, a, b, d, want = 0, acc = 0, f;
    for (i = 0; i < p.length; i++) {
      a = p[i]; b = p[(i + 1) % p.length];
      d = Math.sqrt((b[0] - a[0]) * (b[0] - a[0]) + (b[1] - a[1]) * (b[1] - a[1]));
      seg.push([a, b, d]); total += d;
    }
    want = t * total;
    for (i = 0; i < seg.length; i++) {
      if (acc + seg[i][2] >= want) {
        f = (want - acc) / seg[i][2];
        return [seg[i][0][0] + (seg[i][1][0] - seg[i][0][0]) * f,
                seg[i][0][1] + (seg[i][1][1] - seg[i][0][1]) * f];
      }
      acc += seg[i][2];
    }
    return p[0];
  }

  /* the rank pip in the badge point — shared by all four, and the reason the
     elements above it are drawn top-weighted: the chamber narrows to a point */
  var PIP = 'M50 79.5L53.4 84L50 88.5L46.6 84Z';

  /* Everything the four crests share. Elements arrive as HOLE paths and are
     punched out of the chamber, so the subject is always live foil inside ink
     — the one rule a pale-filled "element on a badge" would break. */
  function badgePlate(holes) {
    var o = A.cut([shell(1)], INK, 0.42), band = [shell(0.95), shell(0.83)], i, p;
    for (i = 0; i < 18; i++) {                                  // studded border track
      p = along(0.89, (i + 0.5) / 18);
      band.push(A.circPath(r2(p[0]), r2(p[1]), i % 6 === 0 ? 1.4 : 1));
    }
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + band.join(' ') + '"/>';
    o += '<path d="' + shell(0.775) + '" fill="none" stroke="' + L2 +
      '" stroke-width="0.6" opacity="0.6"/>';
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + shell(0.72) + ' ' +
      holes.join(' ') + ' ' + PIP + '"/>';
    o += '<path d="' + shell(1) + '" fill="none" stroke="{{color_hex}}" stroke-width="1.6"/>';
    return o;
  }

  /* flame in the badge — the tongue is foil, and an inked heart inside it stops
     it printing as a featureless blob at 19mm */
  A.motif.flamecrest = function () {
    var flame = 'M50 38C55 50 64 55 64 65C64 72 58 76.5 50 76.5C42 76.5 36 72 36 65' +
      'C36 59 40 55.5 43 52.5C42.5 58 45 60.5 47.5 59C50.5 57 49 46 50 38Z';
    var o = badgePlate([flame, A.circPath(37.5, 44, 1.7), A.circPath(62.5, 47, 1.35)]);
    o += '<path fill="' + INK2 + '" opacity="0.88" d="M50 55C52.6 61 55 64.5 55 68.5' +
      'C55 72.5 52.8 74.8 50 74.8C47.2 74.8 45 72.5 45 68.5C45 66 46.2 64 47.6 62' +
      'C47.9 64.6 49 65.4 49.7 64.6C50.9 63.2 49.4 58 50 55Z"/>';
    o += '<path d="M50 71.5c-1.6 0-2.6-1.1-2.6-2.4" fill="none" stroke="' + L2 +
      '" stroke-width="0.6" opacity="0.55"/>';
    o += '<path d="' + flame + '" fill="none" stroke="{{color_hex}}" stroke-width="1.1"/>';
    return o;
  };

  /* wave curl in the badge — a droplet leaning off-axis with a breaking curl
     inked inside it. The lean and the curl are deliberate: a plain symmetric
     drop centred on a plain field is somebody else's mana pip, not ours. */
  A.motif.aquacrest = function () {
    var drop = 'M59 38.5C56 47 63 54 63 62A13 13 0 0 1 37 62C37 54 45 47.5 52 44.5' +
      'C55 43.2 57.5 41 59 38.5Z';
    var o = badgePlate([drop]);
    o += '<path fill="' + INK + '" d="M42 68C41 59 46 52.5 53 53C58 53.4 60.5 57.5 58.6 61.2' +
      'C57.2 63.9 53.6 64.3 51.8 62.3C54.6 62 55.5 59.5 54 57.7C51.3 54.5 46.6 58 46.2 65' +
      'C46 68.6 47 71.2 48.8 73.2C44 72.6 42.3 71 42 68Z"/>';
    o += '<circle cx="58" cy="67" r="1.6" fill="' + INK + '"/>';
    o += '<circle cx="54" cy="71.4" r="1.05" fill="' + INK + '"/>';
    o += '<path d="M45 50.5c2.5-2.4 5-4 7.6-4.8" fill="none" stroke="' + L2 +
      '" stroke-width="0.6" opacity="0.5"/>';
    o += '<path d="' + drop + '" fill="none" stroke="{{color_hex}}" stroke-width="1.2"/>';
    return o;
  };

  /* leaf and vine in the badge — one broad blade with its stem hooked out at
     the base, cut to foil, then veined in ink so the shape has grain instead of
     reading as a flat silhouette. Deliberately ONE blade: the chamber narrows
     to a point, and a second element crowded into it collides with the first —
     overlapping holes flip evenodd back to solid ink and the leaf disappears. */
  A.motif.leafcrest = function () {
    var leaf = 'M63 40C73 52 66 71 45 77C43.6 78 42.6 79 41.5 80.2' +
      'C42.2 78.4 43 76.9 44 75.4C34.5 63 44 46 63 40Z';
    var o = badgePlate([leaf]), i, s, t, bx, by, w;
    var PU = [0.45, -0.89], PP = [0.89, 0.45];       // along the midrib / across it

    for (i = 0; i < 6; i++) {                        // veins swept toward the tip
      t = 0.16 + i * 0.135;
      bx = 62 - 18 * t; by = 41.5 + 34 * t;
      w = 8.4 * Math.pow(Math.sin(Math.PI * t), 0.8);
      for (s = 1; s >= -1; s -= 2) {
        o += '<path d="M' + r2(bx) + ' ' + r2(by) + 'Q' +
          r2(bx + PP[0] * w * 0.45 * s + PU[0] * w * 0.15) + ' ' +
          r2(by + PP[1] * w * 0.45 * s + PU[1] * w * 0.15) + ' ' +
          r2(bx + PP[0] * w * 0.78 * s + PU[0] * w * 0.5) + ' ' +
          r2(by + PP[1] * w * 0.78 * s + PU[1] * w * 0.5) +
          '" fill="none" stroke="' + INK + '" stroke-width="0.75" opacity="0.85"/>';
      }
    }
    o += '<path d="M61.5 42.2C52 52 45.5 63.5 43.4 75" fill="none" stroke="{{color_hex}}" stroke-width="1.2"/>';
    return o;
  };

  /* lightning fork in the badge — main bolt plus a splintered branch, both cut
     to foil so the strike is the brightest thing on the seal */
  A.motif.boltcrest = function () {
    var bolt = 'M57 39L37 64L47.5 64L41 76L64 55L52.5 55Z';
    var fork = 'M41 43L33.5 54L37.5 54L34.5 62L42 51L38 51Z';
    var o = badgePlate([bolt, fork]);
    o += '<path d="M54.5 43L41.5 59.5L49 59.5" fill="none" stroke="' + INK +
      '" stroke-width="1" opacity="0.85"/>';                    // crease down the leading edge
    o += '<path d="M59.5 57.5L47 68.5" fill="none" stroke="' + INK2 +
      '" stroke-width="0.9" opacity="0.8"/>';
    o += '<path d="' + bolt + '" fill="none" stroke="{{color_hex}}" stroke-width="1.2"/>';
    return o;
  };

  /* ——————————— the objects ———————————
     A clutch egg and a set stone: the two things a creature set puts on a card
     back that are not the creature itself. */

  /* patterned egg cradled in a nest. The shell is INK and its bands, speckles
     and the split down the crown are punched to foil — the opposite of the
     crests, because an egg wants to read as a dark object catching light, and
     because a foil egg would give the crack nothing to shine against. */
  A.motif.eggshell = function (seed) {
    var rnd = A.rng(seed || 'eggshell'), o = '', i, k, u;
    var EX = 50, ET = 28, EB = 98, ER = 25.5;

    /* One ovoid profile drives the outline, the bands and the speckle bounds,
       so nothing can spill past the shell edge and re-ink the field. The
       profile is an ELLIPSE skewed heavier at the foot — a sine profile gives
       points at both ends and prints as an almond, not an egg. */
    function hw(t) {
      var d = 2 * Math.min(1, Math.max(0, t)) - 1;
      return ER * Math.sqrt(Math.max(0, 1 - d * d)) * (0.86 + 0.26 * t);
    }
    function ey(t) { return ET + (EB - ET) * t; }
    function far(x) { var t = (x - 50) / 54; return 86 - 6 * (1 - t * t); }
    function near(x) { var t = (x - 50) / 54; return 93 + 17 * (1 - t * t); }

    function ovoid(inset, u0, u1, steps) {
      var lo = [], hi = [], t;
      for (k = 0; k <= steps; k++) {
        /* cosine spacing so the rounded ends get the samples they need — even
           spacing facets the crown into a polygon at print size */
        t = u0 + (u1 - u0) * (1 - Math.cos(Math.PI * k / steps)) / 2;
        lo.push([EX + Math.max(0, hw(t) - inset), ey(t)]);
        hi.unshift([EX - Math.max(0, hw(t) - inset), ey(t)]);
      }
      return poly(lo.concat(hi));
    }

    function twigs(rim, dy, count, span) {
      var s = '', xc, lean, x0, x1;
      for (i = 0; i < count; i++) {
        xc = 5 + i * (90 / (count - 1)) + (rnd() - 0.5) * 4;
        lean = (i % 2 ? 1 : -1) * (2.5 + rnd() * 2.5);
        x0 = xc - span; x1 = xc + span;
        s += '<path d="M' + r2(x0) + ' ' + r2(rim(x0) - dy + lean) + 'Q' + r2(xc) + ' ' +
          r2(rim(xc) - dy + lean * 0.3 + 2) + ' ' + r2(x1) + ' ' + r2(rim(x1) - dy - lean) +
          '" fill="none" stroke="' + (i % 3 ? INK : INK2) + '" stroke-width="' +
          r2(1.5 + rnd() * 1.6) + '" stroke-linecap="round" opacity="' +
          r2(0.7 + rnd() * 0.3) + '"/>';
      }
      return s;
    }

    o += A.cut([], INK, 0.3);                                   // ground smoked, nothing cut yet
    o += twigs(far, 0, 13, 10) + twigs(far, 7, 11, 9);          // far rim, behind the egg

    var holes = [ovoid(0.9, 0.44, 0.545, 12), ovoid(0.9, 0.665, 0.745, 12)];

    var cp = [];                                                // the split, crown to shoulder
    for (i = 0; i <= 9; i++) {
      u = 0.10 + (0.40 - 0.10) * i / 9;
      /* the zigzag tightens as it runs down — a constant-amplitude zigzag reads
         as a decorative squiggle, a narrowing one reads as a crack propagating */
      cp.push([EX + 1.5 + (i % 2 ? 3.4 : -3.4) * (1 - 0.55 * i / 9), ey(u)]);
    }
    holes.push(ribbon(cp, function (t) { return 2.8 - 1.9 * t; }));

    [0.17, 0.25, 0.33, 0.41, 0.60, 0.79, 0.87].forEach(function (uu) {
      var w = hw(uu), c, x, y, r;
      for (c = 0; c < 4; c++) {
        x = EX + (c - 1.5) * (w * 0.52) + (rnd() - 0.5) * 3.4;
        y = ey(uu) + (rnd() - 0.5) * 2;
        r = 1.05 + rnd() * 0.6;
        if (uu < 0.43 && Math.abs(x - 51.5) < 6.5) continue;     // leave the split clean
        if (Math.abs(x - EX) > w - r - 2) continue;              // never break the shell edge
        holes.push(A.circPath(r2(x), r2(y), r2(r)));
      }
    });

    var egg = ovoid(0, 0, 1, 40);
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + egg + ' ' + holes.join(' ') + '"/>';
    o += '<path d="' + egg + '" fill="none" stroke="{{color_hex}}" stroke-width="1.3"/>';

    [0.4925, 0.705].forEach(function (uu) {                     // beading inked back onto the bands
      var w = hw(uu) - 3.4;
      for (k = -2; k <= 2; k++) {
        o += '<circle cx="' + r2(EX + k * (w / 2.4)) + '" cy="' + r2(ey(uu)) +
          '" r="1.15" fill="' + INK + '"/>';
      }
    });

    /* the packed mass of the nest, so the near twigs read as weave laid over
       something solid rather than as loose scribble on the field */
    var mass = 'M0 117';
    for (k = 0; k <= 20; k++) mass += 'L' + r2(k * 5) + ' ' + r2(near(k * 5) + 3);
    o += '<path d="' + mass + 'L100 117Z" fill="' + INK + '" opacity="0.95"/>';
    /* only two near layers: a third rode high enough on the flanks to bury the
       lower band, and the pattern is the whole point of the egg */
    o += twigs(near, 7, 14, 9) + twigs(near, -1, 15, 8);
    o += '<path d="M8 92q42 22 84 0" fill="none" stroke="{{color_hex}}" stroke-width="1.1" opacity="0.9"/>';

    for (i = 0; i < 9; i++) {                                   // sparse glints above the clutch
      o += '<circle cx="' + r2(8 + rnd() * 84) + '" cy="' + r2(6 + rnd() * 20) +
        '" r="' + r2(0.6 + rnd() * 0.9) + '" fill="' + L1 + '" opacity="' +
        r2(0.35 + rnd() * 0.35) + '"/>';
    }
    return o;
  };

  /* a cut energy stone held in a talon mount.
     ⚠ This one is drawn defensively. A circle with a band across its middle and
     a button at the centre is somebody else's property, so: the stone is an
     ELEVEN-sided irregular gem (never a sphere), its facets converge on an
     off-centre culet up-left, its table is an offset pentagon, there is no
     equator and no centre dot, and three talons of three different lengths grip
     it from three different angles. Nothing about it is symmetric. */
  A.motif.energyorb = function (seed) {
    var rnd = A.rng(seed || 'energyorb'), o = '', i, a;
    var GX = 50, GY = 50, CU = [43, 42];                        // gem centre, culet
    var FACE = [24, 19, 22.5, 18.5, 24.5, 20, 23.5, 18, 22, 20.5, 25];
    var v = FACE.map(function (r, k) {
      var t = -Math.PI / 2 + (k / FACE.length) * Math.PI * 2 + 0.19;
      return [GX + Math.cos(t) * r, GY + Math.sin(t) * r * 0.97];
    });
    var gem = poly(v);

    o += A.cut([gem], INK, 0.58);                               // stone = bare foil, field smoked

    for (i = 0; i < 28; i++) {                                  // halo, kept clear of the girdle
      a = (i / 28) * Math.PI * 2 + 0.11;
      o += '<path d="M' + r2(GX + Math.cos(a) * 27) + ' ' + r2(GY + Math.sin(a) * 27) +
        'L' + r2(GX + Math.cos(a) * (27 + (i % 2 ? 6 : 12))) + ' ' +
        r2(GY + Math.sin(a) * (27 + (i % 2 ? 6 : 12))) + '" stroke="' + INK +
        '" stroke-width="' + (i % 2 ? 0.6 : 1.2) + '" opacity="0.45"/>';
    }

    /* facets: wedges from the culet, two left unpainted up-left so the stone
       has one blazing kite instead of an even wash */
    for (i = 0; i < v.length; i++) {
      /* Only the odd facets take ink. Inking nine of eleven turned the stone
         into a grey wash — the gem reads as a gem because most of it is left
         as bare foil and a few facets are struck dark against it. */
      if (i === 9 || i === 10 || i % 2 === 0) continue;
      o += '<path d="' + poly([CU, v[i], v[(i + 1) % v.length]]) + '" fill="' +
        INK + '" opacity="0.46"/>';
      /* only every other edge is struck: an edge on every facet turns the culet
         into a spiderweb of hairlines instead of a cut stone */
      if (i % 2) {
        o += '<path d="M' + r2(CU[0]) + ' ' + r2(CU[1]) + 'L' + r2(v[i][0]) + ' ' + r2(v[i][1]) +
          '" stroke="' + INK + '" stroke-width="0.55" opacity="0.55"/>';
      }
    }
    o += '<path d="' + poly([[38, 34], [51, 37], [53, 46], [44, 51], [36, 43]]) +
      '" fill="none" stroke="' + INK + '" stroke-width="0.9" opacity="0.6"/>';
    /* the pale crossing highlights are gone: L2 on bare foil is the material
       rule's failure case — it lays down almost no ink and prints as nothing */

    /* the mount sits BELOW the stone, never around it — a band across the
       girdle is the exact silhouette this motif must not have */
    var mo = [[18, 88], [50, 112], [82, 88]], mount = ['M18 88Q50 112 82 88L86 95Q50 121 14 95Z'];
    [0.16, 0.33, 0.5, 0.67, 0.84].forEach(function (t) {
      var u = 1 - t;
      mount.push(A.circPath(r2(u * u * mo[0][0] + 2 * t * u * mo[1][0] + t * t * mo[2][0]),
        r2(u * u * mo[0][1] + 2 * t * u * mo[1][1] + t * t * mo[2][1] + 5), 1.7));
    });
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + mount.join(' ') + '"/>';
    o += '<path d="M20 90q30 19 60 0" fill="none" stroke="{{color_hex}}" stroke-width="1.1" opacity="0.9"/>';

    /* three talons, three lengths, three angles — the asymmetry is the point.
       Kept slim on purpose: a claw with any real mass stops reading as a claw
       and starts reading as a fin swallowing the stone. */
    /* every talon ROOTS IN THE MOUNT and ends on the stone. One that starts in
       open field grips nothing and prints as a stray hook, not a claw. */
    [[[28, 92], [21, 70], [33, 45], 7], [[74, 92], [83, 68], [68, 44], 6.5],
     [[80, 94], [95, 60], [66, 39], 5.5]].forEach(function (c) {
      var line = quad(c[0], c[1], c[2], 16);
      o += '<path d="' + ribbon(line, function (t) {
        return c[3] * (1 - t) + 0.3;                            // linear taper to a point
      }) + '" fill="' + INK + '"/>';
      o += '<path d="M' + r2(line[2][0]) + ' ' + r2(line[2][1]) + 'L' +
        r2(line[11][0]) + ' ' + r2(line[11][1]) + '" stroke="' + INK3 +
        '" stroke-width="0.8" opacity="0.7"/>';                 // ridge down the claw's back
    });

    o += '<path d="' + gem + '" fill="none" stroke="{{color_hex}}" stroke-width="1.5"/>';
    for (i = 0; i < 11; i++) {
      a = rnd() * Math.PI * 2;
      var rr = 36 + rnd() * 24;
      o += '<circle cx="' + r2(GX + Math.cos(a) * rr) + '" cy="' + r2(GY + Math.sin(a) * rr * 0.9) +
        '" r="' + r2(0.6 + rnd() * 0.9) + '" fill="' + L1 + '" opacity="' +
        r2(0.35 + rnd() * 0.4) + '"/>';
    }
    return o;
  };
})();
